import React, { useEffect, useState } from "react";
import { Table } from 'antd';
import { useNavigate } from "react-router-dom";
import { local_backend, openapikey } from "../../config";
import "./chat-threads.scss"
import moment from "moment";

const ChatThreads = () => {
  const navigate = useNavigate();
  const [threads, setThreads] = useState([])

  const redirectToThread = (n) => {
    navigate("/chat-threads/" + n.threadId)
  }

  useEffect(() => {
    const createThread = async () => {
      try {
        const response = await fetch(`${local_backend}OpenAPI/getAllThreads`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer sk-proj-${openapikey}`,
            "OpenAI-Beta": "assistants=v2"
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        function compare(a, b) {
          if (a.modifiedOn < b.modifiedOn) {
            return 1;
          }
          if (a.modifiedOn > b.modifiedOn) {
            return -1;
          }
          return 0;
        }


        const data = await response.json();

        let finalData = data.map((n, i) => {
          n = { threadId: n.threadId, ...n.messageContent[n.messageContent.length - 1], messageCount: n.messageContent.length };
          return n
        });

        finalData.sort(compare)
        finalData.forEach((element, i) => {
          element.key = i + 1;
        });

        setThreads(finalData)
      } catch (err) {
        const errorMessage = `Failed to initialize chat: ${err.message}`;
        console.error(errorMessage);
      }
    };

    createThread();
  }, []);

  const columns = [
    {
      title: 'S.No.',
      dataIndex: 'key',
      width: 60
    },
    {
      title: 'Topic',
      dataIndex: 'messageRequest',
      render: (text, row) => {
        return (<div className="topic-name" onClick={() => redirectToThread(row)}>{text}</div>)
      },
    },
    {
      title: 'Date',
      dataIndex: 'modifiedOn',
      render: (text, row) => {
        let date = moment(text);
        let format = "D MMM, YYYY"
        return (<div>{date.format(format)}</div>)
      },
      width: 110
    },
    {
      title: 'Chat Count',
      dataIndex: 'messageCount',
      width: 110
    },
  ];

  return (
    <div className="p-5 font-sofia">
      <div className="text-[30px] font-bold text-left mb-2">Chat Threads</div>
      <Table columns={columns} dataSource={threads} size="small" />
    </div>
  );
};

export default ChatThreads;